import { useLocation } from "react-router-dom";
import { getNarrativeByUser } from "../services/narratives/narrativeAxios";
import { Narrative } from "../store/adsPageStore";
import { Option } from "../components/sidebars/NarrativeSidebar";
import { toast } from "react-hot-toast";

export function useLoadNarratives(
  setNarratives: (narratives: Narrative[]) => void,
  setSelectedNarrative: (n: Narrative | null) => void,
  setProductFilter?: (option: Option | null) => void,
  setAngleFilter?: (option: Option | null) => void,
  setFilteredNarratives?: (narratives: Narrative[]) => void,
  setLoading?: (loading: boolean) => void
) {
  const location = useLocation();

  const setFilterValues = (productInfo: any, sale_angle: string) => {
    if (setProductFilter) {
      setProductFilter({ id: productInfo.id, name: productInfo.name });
    }
    if (setAngleFilter) {
      setAngleFilter({ id: sale_angle || "", name: sale_angle || "" });
    }
  };

  const loadNarratives = async () => {
    setLoading?.(true);
    const narratives = await getNarrativeByUser();
    narratives.forEach((narrative: Narrative) => {
      if (narrative.sale_angle) {
        narrative.sale_angle = narrative.sale_angle
          .replace(/-/g, " ")
          .replace(/^\w/, c => c.toUpperCase());
      }
      if (narrative.product_information?.name) {
        narrative.product_information.name = narrative.product_information.name
          .split(" ")
          .slice(0, 3)
          .join(" ") + "...";
        narrative.product_information.name = narrative.product_information.name
          .replace(/^\w/, c => c.toUpperCase());
      }
    });
    setNarratives(narratives);
    if (setFilteredNarratives) {
      setFilteredNarratives(narratives);
    }
    setLoading?.(false);
    return narratives;
  };

  const loadNarrativesByFunnel = async () => {
    const narratives = await loadNarratives();

    const searchParams = new URLSearchParams(location.search);
    const funnelId = searchParams.get("funnelId");
    const sale_angle = narratives.find((n: Narrative) => n.website_information?.id === funnelId)?.sale_angle || "";

    if (!funnelId) {
      return;
    }

    const matchedNarratives = narratives.filter(
      (n: Narrative) => n.website_information?.id === funnelId
    );
    const matchedNarrative = matchedNarratives?.length > 0 ? matchedNarratives[0] : null;
    if(!matchedNarrative) {
      setFilteredNarratives?.(narratives);
      setSelectedNarrative(null);
      toast.error("No se encontró ninguna narrativa para este funnel", {
        duration: 3000
      });
      return;
    }

    const productInfo = matchedNarrative?.product_information;

    if (productInfo) {
      setFilterValues(productInfo, sale_angle);
    }

    if (setFilteredNarratives) {
      setFilteredNarratives(matchedNarratives);
    }
    setSelectedNarrative(matchedNarrative);
  };

  return { loadNarrativesByFunnel, loadNarratives };
}
